import { Form, Input } from "antd";
import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { RegisterApplicantConstants } from "../../../../common/Constants";
import SelectInput from "../../app/SelectInput";
import { IParty } from "../../../../model/applicant/Party";
import { FormComponentProps } from "antd/lib/form";

const { PARTY_ID } = RegisterApplicantConstants.FIELDS;

export interface State {}

export interface RegisterApplicantFormProps extends FormComponentProps {
  translate: TTranslate;
  parties: IParty[];
  registerFormSubmitEventHandler: any
}

class RegisterApplicantForm extends React.Component<RegisterApplicantFormProps, State> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newSectionData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newSectionData = values;
        }
      });
      return newSectionData;
    });
  }
  render() {
    const { translate, parties, form } = this.props;
    const {getFieldDecorator} = form
    const partyOptions = parties.map((party: IParty) => ({
      id: party.id,
      value: `${party.firstName} ${party.lastName}`
    }));

    return (
      <Form>
        <Form.Item label={translate("register_applicant.party")}>
          {getFieldDecorator(PARTY_ID, {
            rules: [
              {
                required: true,
                message: translate("register_applicant.required_message", {
                  field: translate("register_applicant.party")
                })
              }
            ]
          })(
            <SelectInput
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              placeholder={translate("select.choose")}
              selectOptionKey={"id"}
              selectOptionValue={"value"}
              selectOptions={partyOptions}
              style={{width: "80%"}}
            />
          )}
        </Form.Item>
      </Form>
    );
  }
}

export default RegisterApplicantForm;
